module.exports = __webpack_public_path__ + "img/img1.3d4e9ce7.png";